import React from "react";
import { Icon, IconProps } from "@kernel/react-icons";
import { LayoutFooter } from "@kernel/react-ui-kit";
import { Col, Container, Row } from "react-bootstrap";

export interface FooterProps {
  customer: string;
  title: string;
  version: string;
  fluidContainer?: boolean;
  copyRightIcon?: IconProps;
  className?: string;
}

const defaultCopyRightIcon: IconProps = {
  set: "fa",
  icon: ["regular", "copyright"]
};

export function Footer({
  customer,
  title,
  version,
  fluidContainer = true,
  copyRightIcon = defaultCopyRightIcon,
  className
}: FooterProps) {
  return (
    <LayoutFooter className={className}>
      <Container fluid={fluidContainer}>
        <Row>
          <Col>
            <Icon {...copyRightIcon} className="me-2" />
            <span>{customer}</span>
          </Col>
          <Col className="text-end">
            <span className="me-2">{title}</span>
            <span>Version: {version}</span>
          </Col>
        </Row>
      </Container>
    </LayoutFooter>
  );
}
